import * as React from "react"
import styled from "styled-components"
import { PersonAddIcon } from "../atoms/icons/PersonAddIcon"
import SelectRoleDropdown from "../atoms/inputs/SelectRoleDropdown"
import MemberProfileOverview from "./MemberProfileOverview"
import { Member } from "../../utils/models"
import { CheckCircleIcon } from "../atoms/icons/CheckCircleIcon"
import { MinusIcon } from "../atoms/icons/MinusIcon"

interface Props {
  member: Member
  onClickAdd: (role: string, email: string) => void
  onClickRemoveAddedMember: (email: string) => void
  isAdded: boolean
}

const AddMemberContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const ContentContainer = styled.div<{ isAdded?: boolean }>`
  border-radius: ${(props) => props.theme.borders.softRadius};
  padding: ${(props) => props.theme.spacings.medium};

  :hover {
    background-color: ${(props) => props.theme.colors.greyLight};
  }

  :hover .rolesection {
    display: block;
  }

  :hover .add {
    display: ${(props) => (props.isAdded ? "none" : "block")};
  }

  :hover .remove {
    display: ${(props) => (props.isAdded ? "block" : "none")};
  }
`

const IconContainer = styled.div`
  cursor: pointer;

  :hover {
    filter: brightness(60%);
  }
`

const SelectRoleSection = styled.div`
  display: none;
`

const AddSection = styled.div`
  display: block;
`

const RemoveSection = styled.div`
  display: none;
`

const AddMemberCard: React.FunctionComponent<Props> = ({ member, onClickAdd, isAdded, onClickRemoveAddedMember }) => {
  const [selectedValue, setSelectedValue] = React.useState<string>("Viewer")
  const onSelectRole = (role: string) => {
    setSelectedValue(role)
  }

  return (
    <ContentContainer isAdded={isAdded}>
      <AddMemberContainer>
        <MemberProfileOverview
          imgSrc={member.member?.src ?? ""}
          name={member.member?.name}
          role={member.member?.title}
        />
        <AddSection className="add">
          <IconContainer onClick={() => onClickAdd(selectedValue, member.member?.email)}>
            {isAdded ? <CheckCircleIcon /> : <PersonAddIcon />}
          </IconContainer>
        </AddSection>
        <RemoveSection className="remove">
          <IconContainer onClick={() => onClickRemoveAddedMember(member.member.email)}>
            <MinusIcon />
          </IconContainer>
        </RemoveSection>
      </AddMemberContainer>
      <SelectRoleSection className="rolesection">
        <SelectRoleDropdown title="Select role: " onChange={onSelectRole} defaultValue={selectedValue} />
      </SelectRoleSection>
    </ContentContainer>
  )
}

export default AddMemberCard
